class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._hoverTimeout = null;

    this.addEventListener('mouseenter', this._onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this._onMouseLeave.bind(this));

    const summary = this.mainDetailsToggle.querySelector('summary');
    summary.addEventListener('click', this._onSummaryClick.bind(this));
  }

  _onSummaryClick(event) {
    const url = event.currentTarget.dataset.url;
    if (url && url !== '#' && url !== 'javascript:void(0)') {
      event.preventDefault();
      window.location.href = url;
    }
  }

  // ── Hover open ────────────────────────────────────────────────

  _onMouseEnter() {
    if (this._isMobile()) return;

    // Cancel pending close
    if (this._hoverTimeout) {
      clearTimeout(this._hoverTimeout);
      this._hoverTimeout = null;
    }

    // Close all other open mega menus instantly
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu._closeImmediately();
    });

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.classList.remove('mega-menu--closing');
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
      this.onToggle();
    }
  }

  // ── Hover close ───────────────────────────────────────────────

  _onMouseLeave() {
    if (this._isMobile()) return;
    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    // Delay before closing so user can move cursor into the mega menu
    this._hoverTimeout = setTimeout(() => {
      this._closeWithAnimation();
    }, 300);
  }

  _closeWithAnimation() {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    this.mainDetailsToggle.classList.add('mega-menu--closing');

    const onEnd = () => {
      this.content.removeEventListener('transitionend', onEnd);
      this._closeImmediately();
    };

    this.content.addEventListener('transitionend', onEnd);

    // Safety fallback if transitionend doesn't fire
    this._fallbackTimeout = setTimeout(() => {
      this.content.removeEventListener('transitionend', onEnd);
      this._closeImmediately();
    }, 350);
  }

  _closeImmediately() {
    clearTimeout(this._fallbackTimeout);
    this.mainDetailsToggle.classList.remove('mega-menu--closing');
    this.close();
  }

  // ── Helpers ───────────────────────────────────────────────────

  _isMobile() {
    return window.innerWidth < 990;
  }

  // ── Existing toggle (sets header CSS var) ─────────────────────

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
